class scrollHelper{
	constructor() {
		
	}

	to(el, tar, buff) {
		$(el).click(function (e) {
			e.preventDefault();
			var target = typeof tar === 'undefined' ? $(this).attr('href') : tar,
				buffer = typeof buff === 'undefined' ? parseInt($('body').css('margin-top')) : buff,
				scrollDest = parseInt($(target).offset().top - buffer);
			$('html, body').animate({
				scrollTop: scrollDest,
			}, 1000);
		});
	}

	toggleHeaderVisibility() {
		let headerElem = document.getElementById('main-nav');
		let headerElemHeight = headerElem.offsetHeight;
		let footerElem = document.getElementById('footer');
		let visibleClassName = 'visible-to-user';
		let outOfDomClassName = 'out-of-dom';
		let duration = 250;

		window.onscroll = () => {
			if (parseInt(footerElem.getBoundingClientRect().top) <= headerElemHeight) {
				headerElem.classList.add(visibleClassName);
				setTimeout(() => headerElem.classList.add(outOfDomClassName), duration);
			} else {
				headerElem.classList.remove(outOfDomClassName);
				setTimeout(() => headerElem.classList.remove(visibleClassName));
			}
		};
	}
}
window.app.add('scroll', new scrollHelper());